<template>
  <article>
    <h1 class="mb-[24px] font-roboto text-[32px] font-medium leading-6">
      Спецпроекты
    </h1>
    <CardsSpecialProjectSection
      v-for="(project, key) in specialProjects"
      :key="key"
      :data="project"
      :type="project.type"
    />
    <CommonBlocksPageFooterBlocks />
  </article>
</template>

<script setup>
import specialProjects from '@/assets/data/special-projects';

useHead({
  title: 'Спецпроекты',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: 'Спецпроекты.',
    },
  ],
});
</script>

<style lang="scss"></style>
